import React from 'react';
import PropTypes from 'prop-types';

const ThumbnailPreview = ({
  thumbnailUrl,
  onImageClick,
  onChangeImageClick
}) => {
  const thumbnailIsGif = () => thumbnailUrl.match(/\.gif$/);

  const ClickablePreview = () => (
    <div
      data-testid="thumbnail-preview-container"
      role="button"
      onClick={onImageClick}
      onKeyDown={onImageClick}
      className="croppable-thumbnail clickable inline"
      tabIndex={0}
    >
      <div className="crop-icon circle">
        <i className="material-icons md-18">crop</i>
      </div>
      <img src={thumbnailUrl} alt="creative thumbnail" />
    </div>
  );

  const NonClickablePreview = () => (
    <div
      data-testid="thumbnail-preview-container"
      className="croppable-thumbnail inline"
    >
      <img src={thumbnailUrl} alt="creative thumbnail" />
    </div>
  );

  return (
    <div className="centered">
      {thumbnailIsGif() ? <NonClickablePreview /> : <ClickablePreview />}
      <div className="button-container text-center">
        <button
          className="btn btn-link"
          onClick={onChangeImageClick}
          type="button"
        >
          Change
        </button>
      </div>
    </div>
  );
};

ThumbnailPreview.propTypes = {
  thumbnailUrl: PropTypes.string.isRequired,
  onImageClick: PropTypes.func.isRequired,
  onChangeImageClick: PropTypes.func.isRequired
};

export default ThumbnailPreview;
